import produce from 'immer';
import { RequestsAction } from '../actions/Requests';
import * as Constants from '../constants/action-constants';
import { requestStatus } from '../initial-state';
import initialState from '../InitialState';
import { RequestStatus } from '../types/Requests';

const requests = (
  state: RequestStatus = initialState.requestStatus,
  action: RequestsAction
): RequestStatus => {
  return produce<RequestStatus, RequestStatus>(state, draft => {
    switch (action.type) {
      case Constants.POLL_REQUEST_DETAILS:
        draft.failed = false;
        draft.fetching = true;
        break;
      case Constants.POLL_REQUEST_DETAILS_SUCCESS:
        draft.fetching = false;
        draft.request = action.payload.request;
        break;
      case Constants.POLL_REQUEST_DETAILS_FAILED:
        draft.failed = true;
        draft.fetching = false;
        break;
      case Constants.SUBMIT_RETRY_REQUEST:
        draft.retryFailed = false;
        draft.retryLoading = true;
        break;
      case Constants.SUBMIT_RETRY_REQUEST_FAILED:
        draft.retryFailed = true;
        draft.retryLoading = false;
        break;
      case Constants.SUBMIT_RETRY_REQUEST_SUCCESS:
        draft.retryFailed = false;
        draft.retryLoading = false;
        break;
      case Constants.CLEAR_RETRY_REQUEST_FAILED_STATUS:
        draft.retryFailed = false;
        break;
      case Constants.CLEAR_REQUEST_DETAILS:
        Object.assign(draft, requestStatus);
        draft.request = undefined;
      // no default
    }
  });
};

export default requests;
